"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const ramda_1 = __importDefault(require("ramda"));
const entry_nostyle_1 = __importDefault(require("react-datetime-picker/dist/entry.nostyle"));
const styled_components_1 = __importStar(require("styled-components"));
const luxon_1 = require("luxon");
const library_1 = require("library");
const Container_1 = require("../Input/Container");
const Icon_1 = require("../Icon");
const Wrapper = (0, styled_components_1.default)(entry_nostyle_1.default) `
  ${Container_1.InputContainerStyle};

  width: auto;

  .react-datetime-picker {
    display: inline-flex;
    position: relative;
  }
  
  .react-datetime-picker,
  .react-datetime-picker *,
  .react-datetime-picker *:before,
  .react-datetime-picker *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .react-datetime-picker--disabled {
    background-color: #f0f0f0;
    color: #6d6d6d;
  }
  
  .react-datetime-picker__wrapper {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: none;
  }
  
  .react-datetime-picker__inputGroup {
    min-width: calc(4px + (4px * 3) + 0.54em * 6 + 0.217em * 2);
    flex-grow: 1;
    padding: 0 2px;
  }
  
  .react-datetime-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
  }
  
  .react-datetime-picker__inputGroup__divider,
  .react-datetime-picker__inputGroup__leadingZero {
    display: inline-block;
  }
  
  .react-datetime-picker__inputGroup__input {
    min-width: 0.54em;
    height: calc(100% - 2px);
    position: relative;
    padding: 1px;
    border: none;
    background: none;
    font: inherit;
    box-sizing: content-box;
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }
  
  .react-datetime-picker__inputGroup__input::-webkit-outer-spin-button,
  .react-datetime-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
  
  .react-datetime-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
  }
  
  .react-datetime-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }
  
  .react-datetime-picker__inputGroup__amPm {
    font: inherit;
    -webkit-appearance: menulist;
    -moz-appearance: menulist;
    appearance: menulist;
  }
  
  .react-datetime-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
  }
  
  .react-datetime-picker__button:enabled {
    cursor: pointer;
  }
  
  .react-datetime-picker__button:enabled:hover .react-datetime-picker__button__icon,
  .react-datetime-picker__button:enabled:focus .react-datetime-picker__button__icon {
    stroke: #0078d7;
  }
  
  .react-datetime-picker__button:disabled .react-datetime-picker__button__icon {
    stroke: #6d6d6d;
  }
  
  .react-datetime-picker__button svg {
    display: inherit;
  }
  
  .react-datetime-picker__calendar,
  .react-datetime-picker__clock {
    z-index: 1;
  }
  
  .react-datetime-picker__calendar--closed,
  .react-datetime-picker__clock--closed {
    display: none;
  }
  
  .react-datetime-picker__calendar {
    width: 350px;
    max-width: 100vw;
  }
  
  .react-datetime-picker__calendar .react-calendar {
    border-width: thin;
  }
  
  .react-datetime-picker__clock {
    width: 200px;
    height: 200px;
    max-width: 100vw;
    padding: 25px;
    background-color: white;
    border: thin solid #a0a096;
  }
`;
const DatePicker = ({ onChange, value, }) => {
    const theme = (0, styled_components_1.useTheme)();
    const selected = react_1.default.useMemo(() => {
        if (typeof value === 'string') {
            return (0, library_1.toDateTime)(value).toJSDate();
        }
        return value === undefined ? undefined : value.toJSDate();
    }, [value]);
    const handleOnChange = react_1.default.useCallback((value) => {
        if (ramda_1.default.isNil(value)) {
            onChange(undefined);
            return;
        }
        const next = luxon_1.DateTime.fromJSDate(value);
        if (next.isValid) {
            onChange(next);
        }
    }, [onChange]);
    return ((0, jsx_runtime_1.jsx)(Wrapper, { clearIcon: (0, jsx_runtime_1.jsx)(Icon_1.Icon, Object.assign({ color: theme.Color.Text.Secondary }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon.X, {}) })), calendarIcon: (0, jsx_runtime_1.jsx)(Icon_1.Icon, Object.assign({ color: theme.Color.Text.Secondary }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon.Calendar, {}) })), value: selected, onChange: handleOnChange }));
};
exports.DatePicker = DatePicker;
